import React ,{useState, useEffect} from 'react';

import { createDirectus, rest, createItem } from '@directus/sdk';

export default function Contact(){

    const client = createDirectus('https://cms.lizakhan.com').with(rest());
    const [inputs, setInputs] = useState({});

    const handleChange = (event) => {
	const name = event.target.name;
	const value = event.target.value;
	setInputs(values => ({...values, [name]: value}))
    }

    
    const handleSubmit = (event) => {
	event.preventDefault();
	let keys = Object.keys(inputs);

	keys.forEach((key) => {
	   // alert(`There are ${inputs[key]} ${key}`);
	});

	const name = inputs['full_name'];
	const email = inputs['email_address'];
	const phone = inputs['phone_number'];
	const enquiry = inputs['your_enquiry'];
	const agreeInfo = inputs['agree_info'];
	var jsonAgree = JSON.stringify({ 'agreeInfo' : agreeInfo });
	
	try {
	    const form = document.getElementById('userDataForm');
	    console.log('creating');
	    client.request(
		createItem('contacts', {
		    name,
		    email,
		    phone,
		    enquiry,
		    jsonAgree
		})
	    );
	    // replace form with successfully submitted message here?
	    // Show success message
	    showSuccessMessage();
      
	    // Reset the form
	    form.reset();
	} catch (error) {
	    console.log(error);
	}

    }

    function showSuccessMessage() {
      // Get the success message element
      const successMessage = document.getElementById('successMessage');
      
      // Show the success message
      successMessage.style.display = 'block';
      
      // Scroll to the top to make sure the message is visible
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      // Optionally, hide the message after a few seconds
      setTimeout(() => {
        successMessage.style.display = 'none';
      }, 5000); // Hide after 5 seconds
    }
    
    const handleSubmit2 = async (formData) => {
	// this is the new react 19 way of submitting forms directly and async via javascript from action
	const name = formData.get('full_name');
	const email = formData.get('email_address');
	const phone = formData.get('phone_number');
	const enquiry = formData.get('your_enquiry');

	try {
	    console.log('creating');
	    await client.request(
		createItem('contacts', {
		    name,
		    email,
		    phone,
		    enquiry,
		})
	    );
	} catch (error) {
	    console.log(error);
	}
    };


    const [content,setContent] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    // content table has just a title, textKey, image and large text body for general purpose articles
    // need to filter on textKey for the exact article to retrieve
    const cUrl = "https://cms.lizakhan.com/items/content?filter[textKey][_eq]=contactUs"


        useEffect(()=>{
	fetch(cUrl).then(res => res.json()).then(result => {
	    setLoading(true);
	    console.log(result.data);
	    setContent(result.data);
	}).catch(error =>{
	    setLoading(true);
	    setError(error);
	})
    }, []);




    if(error){
	return <div> Error: {error}</div>;
    } else if(!loading){
	return <div>Loading ...</div>;
    } else{
    
    return (
	<main>
	    <div className="container px-4 py-5">
		<h2 className="pb-2 border-bottom">Get in touch</h2>
		<div class="container my-5">
		    <div class="row justify-content-center">
			{content &&  content.map(item =>
			    <div class="col-md-8 col-lg-6">
				<p className="lead" >{item.lead}</p>
				<h4 className="my-4">Contact us at:</h4>
				<div class="row">
				    <img src={"https://cms.lizakhan.com/assets/"+item.image} class="contactInfoImg col-md-4 col-lg-3" />
				    <div class="col-md-8 col-lg-4">			    
					<p style={{textAlign: 'justify'}} className="lead contactInfo" >{item.body}</p>
				    </div>
				    <h4 className="my-4">Visit us at:</h4>
				    <p className="lead"  dangerouslySetInnerHTML={{ __html: item.main }} />
				</div>
			    </div>
			)}
			<div class="col-md-8 col-lg-6">
			    <div class="card shadow-sm">
				<div id="successMessage" class="alert alert-success mb-4" style={{display: 'none'}}>
				    <strong>Success!</strong> Your form has been submitted successfully.
				</div>
				<div class="card-body p-4 p-md-5">
				    <form id="userDataForm" onSubmit={handleSubmit}>
					<h1 class="h3 mb-2">How can we assist?</h1>
					<p class="text-muted mb-4">Please let us know how we can help below</p>
					
					<div class="mb-3">
					    <label for="name" class="form-label">Full Name</label>
					    <input id="name" name="full_name" class="form-control" required onChange={handleChange} />
					</div>
					
					<div class="mb-3">
					    <label for="email" class="form-label">Email Address</label>
					    <input type="email" name="email_address" id="email" class="form-control" required onChange={handleChange} />
					</div>
					
					<div class="mb-3">
					    <label for="phone" class="form-label">Phone Number</label>
					    <input type="tel" name="phone_number" id="phone" class="form-control" required onChange={handleChange} />
					</div>
					
					<div class="mb-3">
					    <label for="enquiry" class="form-label">My enquiry</label>
					    <textarea id="enquiry" name="your_enquiry" rows="4" class="form-control" required placeholder="Enter your enquiry..." onChange={handleChange}></textarea>
					</div>
					
					<div class="mb-4 form-check">
					    <input type="checkbox" id="agree" name="agree_info" class="form-check-input" onChange={handleChange} />
					    <label for="agree" class="form-check-label">Agree to be contacted</label>
					</div>
					
					<div class="d-grid">
					    <button type="submit" class="btn btn-primary">Submit</button>
					</div>
				    </form>
				</div>
			    </div>
			</div>
		    </div>
		</div>
	    </div>	    
	</main>
    );
    }
}




